import { cacheService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  ADD_NEW_EXPORT_JOB,
  UPDATE_EXPORT_JOB_STATUS,
  DISMISS_AND_CLEAR_JOB,
  UPDATE_ACTIVE_TOAST_ID,
  CACHE_JOB_BEEN_CHECKED
} from './mutationTypes';

function getIndex(items, jobId) {
  return items.findIndex(w => w.id == jobId);
}

function clearJobStatusInterval(state, jobId) {
  clearInterval(state.intervalStatusJobsHandler[jobId]);
  delete state.intervalStatusJobsHandler[jobId];
}

function getPendingJobsCacheKey(state, accountId) {
  return state.pendingJobsExportCacheKey + accountId;
}

function addJobIdToCache(state, accountId, job, intervalStatusJobHandler) {
  let jobs = cacheService.get(getPendingJobsCacheKey(state, accountId));
  if (!jobs) {
    jobs = {};
  }

  job.intervalStatusJobHandler = intervalStatusJobHandler;

  jobs[job.id] = job;
  cacheService.set(getPendingJobsCacheKey(state, accountId), jobs, {
    persistence: true
  });
}

function removeJobIdFromCache(state, accountId, jobId) {
  const jobs = cacheService.get(getPendingJobsCacheKey(state, accountId));
  try {
    delete jobs[jobId];
    cacheService.set(getPendingJobsCacheKey(state, accountId), jobs, {
      persistence: true
    });
  } catch (e) {
    //
  }
}

export default {
  [ADD_NEW_EXPORT_JOB](state, { accountId, jobId, jobType, exportName, downloadTitle, jobStatusHandler, isRestoringPendingJob, isProgressIndefinite }) {
    const job = {
      id: jobId,
      name: exportName,
      type: jobType,
      downloadTitle,
      isProgressIndefinite
    };

    const intervalStatusJobHandler = setInterval(function () {
      try {
        jobStatusHandler();
      } catch (error) {
        clearJobStatusInterval(state, jobId);
      }
    }, 3000); 
    
    state.intervalStatusJobsHandler[job.id] = intervalStatusJobHandler;
    state.exportJobs.unshift(job);
    state.exportJobsStatus.unshift({ id: job.id});

    if (!isRestoringPendingJob) {
      addJobIdToCache(state, accountId, job, intervalStatusJobHandler);
    }
  },

  [UPDATE_EXPORT_JOB_STATUS](state, jobStatus) {
    state.exportJobsStatus.splice(getIndex(state.exportJobsStatus, jobStatus.id), 1, jobStatus);

    if (jobStatus.status === 'Ready' || jobStatus.status === 'Error') {
      clearJobStatusInterval(state, jobStatus.id);
    }
  },
  
  [DISMISS_AND_CLEAR_JOB](state, { jobId, accountId }) {
    clearJobStatusInterval(state, jobId);
    removeJobIdFromCache(state, accountId, jobId);

    const indexExportJob = getIndex(state.exportJobs, jobId);
    if (indexExportJob > -1) {
      state.exportJobs.splice(indexExportJob, 1);
    }

    const indexExportJobStatus = getIndex(state.exportJobsStatus, jobId);
    if (indexExportJobStatus < -1) {
      state.exportJobsStatus.splice(indexExportJobStatus, 1);
    }

    if (_.isEmpty(state.exportJobs)) {
      utilities.clearExportToaster(state.activeToastId);
      state.activeToastId = null;
    }
  },

  [UPDATE_ACTIVE_TOAST_ID](state, toastId) {
    if (!state.activeToastId) {
      state.activeToastId = toastId;
    }
  },

  [CACHE_JOB_BEEN_CHECKED](state) {
    state.pendingExportJobsChecked = true;
  }
};